// Windows 8 mobile Responsive utility
if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
  var msViewportStyle = document.createElement('style')
  msViewportStyle.appendChild(
    document.createTextNode(
      '@-ms-viewport{width:auto!important}'
    )
  )
  document.querySelector('head').appendChild(msViewportStyle)
}
// Jquery functions
jQuery(document).ready(function () {
  // LazyLoading
  jQuery("img").unveil(500, function () {
    jQuery(this).on('load', function () {
      jQuery(this).removeAttr("data-src");
    });
  });
  jQuery('.modal').on('shown.bs.modal', function (e) {
    jQuery(".modal img").trigger("unveil");
  });
  jQuery("#nav-opener").click(function(){
    jQuery(this).toggleClass("is-active");
    jQuery("#nav-container").toggleClass("is-active");
  });
  jQuery(".footer__box").matchHeight();
  jQuery("select").selectric();
  jQuery("#go-to").click(function(){
    jQuery("html, body").animate({
      scrollTop: jQuery($.attr(this, 'href')).offset().top
    }, 1000);
    return false;
  });
  jQuery('.datepicker').pickadate();
  jQuery('.timepicker').pickatime();
  jQuery(".entry-content table, .modal table").each(function () {
    jQuery(this).addClass("table").wrap("<div class=\"table-responsive\"></div>");
  });
  jQuery(".entry-content iframe").each(function () {
    jQuery(this).addClass("embed-responsive-item").wrap("<div class=\"embed-responsive embed-responsive-16by9\"></div>");
    jQuery(this).removeAttr("width");
    jQuery(this).removeAttr("height");
  });
  jQuery('[data-toggle="tooltip"]').tooltip();
  jQuery('#enter-time').countdown("2017/10/20", function(event) {
    var totalHours = event.offset.totalDays * 24 + event.offset.hours;
    jQuery('.hours').html(totalHours);
    jQuery('.minutes').html(event.strftime('%M'));
    jQuery('.seconds').html(event.strftime('%S'));
   });
   jQuery(".player__close").click(function(){
     jQuery(this).parents(".player__row").find(".player__name").dropdown('toggle');
   });
   jQuery(".player__popup").click(function(event){
     event.stopPropagation();
   });
});
